import React from 'react';

const EULA = () => {
  return (
    <div className="text-gray-700 dark:text-gray-300 text-xs sm:text-sm space-y-3 leading-relaxed max-w-full">
      <div className="text-center mb-4">
        <h3 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white">
          END USER LICENSE AGREEMENT
        </h3>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
          Last Updated: {new Date().toLocaleDateString()}
        </p>
      </div>
      
      <div className="space-y-3">
        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">1. Acceptance of Terms</h4>
          <p className="text-xs leading-relaxed">
            By using this software, you agree to be bound by this agreement between you and Fresnel Inc. 
            If you do not agree, do not use the software.
          </p>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">2. License Grant</h4>
          <p className="text-xs leading-relaxed mb-1">
            Fresnel Inc. grants you a limited, non-exclusive, non-transferable license to use the software.
          </p>
          <ul className="list-disc list-inside text-xs space-y-0.5 ml-2">
            <li>You may use the software per your subscription plan</li>
            <li>You may not copy, modify, reverse engineer, or redistribute</li>
            <li>You may not remove proprietary notices</li>
          </ul>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">3. Intellectual Property</h4>
          <p className="text-xs leading-relaxed">
            The software is licensed, not sold. All rights remain with Fresnel Inc.
          </p>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">4. Subscription & Payment</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5 ml-2">
            <li><strong>Term:</strong> Valid for selected period (1-12 months, 30 days each)</li>
            <li><strong>Payment:</strong> $1.00 USD per month, non-refundable</li>
            <li><strong>Renewal:</strong> Does not auto-renew, purchase new subscription before expiry</li>
          </ul>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">5. Data & Privacy</h4>
          <p className="text-xs leading-relaxed">
            We collect name, email, company info, payment details, and machine codes for license validation. 
            Your data is used for license management, support, and payments only. We implement security measures 
            and do not sell your data.
          </p>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">6. Warranty Disclaimer</h4>
          <p className="text-xs leading-relaxed font-medium">
            SOFTWARE IS PROVIDED "AS IS" WITHOUT ANY WARRANTY. We do not guarantee it will meet your 
            requirements or be error-free.
          </p>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">7. Limitation of Liability</h4>
          <p className="text-xs leading-relaxed font-medium">
            FRESNEL INC. SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, OR CONSEQUENTIAL DAMAGES. 
            Maximum liability limited to fees paid in the last 12 months.
          </p>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">8. Termination</h4>
          <p className="text-xs leading-relaxed">
            You may terminate by ceasing use. We may terminate if you violate terms. 
            Upon termination, you must destroy all copies.
          </p>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">9. General Provisions</h4>
          <ul className="list-disc list-inside text-xs space-y-0.5 ml-2">
            <li>Governed by applicable laws</li>
            <li>This is the entire agreement</li>
            <li>We may modify terms; continued use means acceptance</li>
            <li>You must comply with export laws</li>
          </ul>
        </section>

        <section>
          <h4 className="font-semibold text-gray-900 dark:text-white mb-1">10. Contact</h4>
          <p className="text-xs leading-relaxed">
            Fresnel Inc. | Email: support@fresnel.com | Website: www.fresnel.com
          </p>
        </section>
      </div>

      <div className="mt-4 p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
        <p className="font-semibold text-gray-900 dark:text-white text-xs mb-1">
          ⚠️ IMPORTANT
        </p>
        <p className="text-xs leading-relaxed">
          By clicking "Accept", you confirm you have read and agree to be bound by these terms. 
          If you do not agree, do not proceed.
        </p>
      </div>
    </div>
  );
};

export default EULA;




